import { surface } from "./foundation";
export const Textarea = surface("textarea", "textarea", "cyra-input cyra-textarea");
